<div class="text-center">
  <mat-horizontal-stepper orientation="vertical" (click)="onChangeStep()" #stepper>
    <mat-step
      *ngFor="let workInstruction of store.data$(); let i = index"
      [ngClass]="{ 'selected-step': stepper.selectedIndex === i }"
      label="{{ workInstruction.id }}"
      class="active"
    >
      <ng-template matStepLabel>
        <div class="text-left">
          <p class="mb-1">{{ workInstruction.name }}</p>
          <p class="mb-0 f-11 fw-600 pt-1 stepper-label-color" *ngIf="workInstruction.timeToComplete">
            {{ workInstruction.timeToComplete }}
          </p>
        </div>
      </ng-template>
      <ng-template matStepContent>
        <div *ngIf="this.selectedRows().length === 1">
          <button mat-button (click)="initializeEdit()">{{ 'button.edit' | translate }}</button>
          <button mat-button (click)="initializeDelete()">{{ 'button.delete' | translate }}</button>
          <button mat-button (click)="openSaveAsTemplateModal()">
            {{ 'page.workInstructions.button.saveAsTemplate' | translate }}
          </button>
        </div>
      </ng-template>
    </mat-step>
    <ng-template matStepperIcon="edit" let-index="index">
      {{ index + 1 }}
    </ng-template>
    <ng-template matStepperIcon="number" let-index="index">
      {{ index + 1 }}
    </ng-template>
  </mat-horizontal-stepper>
  <button mat-raised-button (click)="initializeAdd()">
    <mat-icon>add</mat-icon>
    {{ 'button.addContext' | translate: { context: 'field.workInstructionStep' | translate } }}
  </button>
</div>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()">
    <div mat-dialog-content>
      <div class="row">
        <mat-form-field appearance="outline" *ngIf="!isBulkEdit()">
          <mat-label>{{ 'field.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
          <mat-error [control]="addEditForm.get('name')"></mat-error>
        </mat-form-field>
        <mat-form-field class="pb-075" appearance="outline" *ngIf="!isBulkEdit()">
          <mat-label>{{ 'field.timeToComplete' | translate }}</mat-label>
          <input
            matInput
            type="text"
            placeholder="00:00:00"
            formControlName="timeToComplete"
            pattern="^\d{1,4}:[0-5]\d:[0-5]\d$"
          />
          <mat-hint>{{ 'workInstruction.timeToCompleteHint' | translate }}</mat-hint>
          <mat-error [control]="addEditForm.get('timeToComplete')"></mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" *ngIf="!isBulkEdit()">
          <mat-label>{{ 'field.order' | translate }}</mat-label>
          <input matInput type="number" formControlName="order" />
          <mat-error [control]="addEditForm.get('order')"></mat-error>
        </mat-form-field>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
